import React, { useMemo } from 'react';
import { TBaseTagContext } from '../types';
import UniversalChildren from '../../UniversalTag/UniversalChildren';
import { find, isPlainObject } from 'lodash';
import { TTag } from './types';
import { validate } from '@krugom/validator';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { selectUnits } from '../../../store/selector/selectUnits';
import { TValidationScheme } from '@krugom/validator/dist/types';

export const CustomUnit: React.FC<{
  tagProps: TTag;
  context: Partial<TBaseTagContext>;
}> = React.memo(({ tagProps, context }) => {
  const validationScheme: TValidationScheme = useMemo(
    () => ({
      type: 'object',
      properties: {
        unit: {
          type: 'object',
          required: true,
          properties: {
            type: { type: 'string', required: true },
            id: { type: 'string', required: !tagProps.unit?.props },
            props: {
              type: 'custom',
              validator: (v: any) => isPlainObject(v),
              required: !tagProps.unit?.id,
            },
          },
        },
      },
    }),
    [tagProps.unit?.id, tagProps.unit?.props]
  );

  const result = validate(tagProps, validationScheme);

  const selector = useSelector((state: RootState) => selectUnits(state, tagProps.unit.type));
  const unit = useMemo(
    () => {
      if (tagProps.unit.id) return selector[tagProps.unit.id];
      if (tagProps.unit.props) return find(selector, tagProps.unit.props);
      return;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tagProps.unit?.id, tagProps.unit?.props, selector]
  );

  const childrenContext = useMemo(
    () => ({
      ...context,
      unit,
    }),
    [context, unit]
  );

  if (!result.isValid) {
    console.error(result.errors);
    return <UniversalChildren context={context}>{tagProps.children}</UniversalChildren>;
  }

  return <UniversalChildren context={childrenContext}>{tagProps.children}</UniversalChildren>;
});

CustomUnit.displayName = 'CustomUnit';
